<template>
  <div id="setting">
    <div class="setting">
      <van-cell-group>
        <van-cell title="个人资料" is-link value="" size="large" to="/userInfo"/>
        <van-cell title="字体大小" is-link :value="fontNum == 0? '标准' : fontNum == 1? '大' : fontNum == 2? '超大' : '标准'" size="large" @click="showRoles = true"/>
        <van-cell title="清除缓存" size="large" @click="clearSession"/>
        <van-cell title="更新日志" is-link value="" size="large" to="/releaseNotes"/>
      </van-cell-group>
      <van-button type="default" square block @click="logout" v-if="disableLogout">退出登录</van-button>
    </div>
    <van-action-sheet
      v-model="showRoles"
      :actions="actions"
      cancel-text="取消"
      @cancel="onCancel"
      @select="onSelect"
    />
  </div>
</template>
<script>
import {ActionSheet, Toast,CellGroup,Cell} from 'vant';
import {logout} from "@/api";
import {env} from '@/utils/commons'
export default {
  components: {
    [ActionSheet.name]:ActionSheet,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  data() {
    return {
      showRoles:false,
      actions: [
        {name:'标准',id:0},
        {name:'大',id:1},
        {name:'超大',id:2}
      ],
      fontNum: this.$store.state.sizeNum,
      disableLogout: false
    }
  },
  created() {
    if (env.wechat || env.dingtalk || env.welink || env.zhuoyun || env.toon || env.app) {
      this.disableLogout = false;
    } else {
      this.disableLogout = true;
    }
  },
  methods: {
    onSelect(item){
      this.fontNum = item.id;
      window.document.documentElement.setAttribute('data-size', item.id)
      this.showRoles = false;
      this.$store.commit('updateFont', item.id)
    },
    onCancel(){
      this.showRoles = false;
    },
    logout(){
      let toast = Toast({
        forbidClick: true,
        message: '退出登录中,请稍后...',
      })
      logout().then(resp=>{
        if(resp===true || resp==='true'){
          Toast({
            duration: 1,
            message: '退出登录成功'
          });
          sessionStorage.clear();
          this.$router.replace('/home')
              .catch(err => console.warn(err));
          toast.clear();

        }else{
          toast.clear();
          Toast("退出登录失败")
          console.warn(resp)
        }
      }).catch(err=>{
        toast.clear();
        console.warn(err)
      })
    },
    clearSession() {
      sessionStorage.clear();
      localStorage.clear();
      Toast('清除成功');
    }
  }
}
</script>
<style scoped lang="scss">
@import "~@/assets/css/theme/theme";
.setting {
  .van-cell-group {
    margin-bottom: 12px;
    .van-cell__title span {
      @extend .font16;
    }.van-cell__value span {
       @extend .font13;
     }
  }
  .van-button {
    border: none;
    color: var(--main-color);
    @extend .font16;
  }
}
</style>
